import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getAddBgdToTransparentImgEnabled,
  getImgBackgroundColorForPng,
  getIsDamImageV2Enabled,
  getIsDamImageV2EnabledPLP,
  getIsDamImageV2EnabledPDP,
  getIsGroupModulesEnabled,
  getIsGroupModulesEnabledApp,
  getOutfitPillWidthVal,
  getOutfitPillHeightVal,
  getOutfitPillColorVal,
  getOutfitPillFontSizeVal,
  getIsHeaderSectionDisabledWeb,
  getIsHeaderSectionDisabledApp,
  getOutfitPillBgColorVal,
} from '@tcp/core/src/reduxStore/selectors/labels.selectors';
import {
  getIsNewLoginScreen,
  getIsHpHLSEnabled,
  disableVideosForAppleDevice,
  getIsModuleJV2,
  getIsOutfitCarouselModuleV2,
  getOutfitCarouselPillCategories,
  getIsOutfitCarouselPillEnabled,
  getOutfitCarouselPillCategoriesAB,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getCurrentNavId } from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.selectors';
import { getCategoryId } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.selectors';
import LabelsContext from './LabelsContext';

class LabelsProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHeaderStickyClassPresent: false,
      stickyHeaderHeight: null,
      middleNavHeight: null,
    };
  }

  componentDidMount() {
    const node = document.getElementsByClassName('middle-nav-section')[0];
    this.header = document.getElementById('scrollStickyHeader');
    this.updateClassState();

    if (this.header) {
      this.observer = new MutationObserver(this.updateClassState);
      this.observer.observe(this.header, { attributes: true, attributeFilter: ['class'] });
    }
    if (node && node.offsetHeight) {
      this.setState({ middleNavHeight: node.offsetHeight });
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updateClassState = () => {
    if (this.header) {
      this.setState({
        isHeaderStickyClassPresent: this.header.classList.contains('header-sticky'),
        stickyHeaderHeight: this.header.offsetHeight,
      });
    }
  };

  render() {
    const {
      addBgdToTransparentImgEnabled = null,
      children,
      backgroundColorsForPng = {},
      isDamImageV2Enabled = false,
      isDamImageV2EnabledPLP = false,
      isDamImageV2EnabledPDP = false,
      isGroupModulesEnabled = false,
      isGroupModulesEnabledApp = false,
      isNewLoginScreen = false,
      isHpHLSEnabled = false,
      isModuleJAppV2 = false,
      isOutfitCarouselModuleAppV2 = false,
      disableVideosForAppleDeviceValue = true,
      outfitCarouselPillCategories = [],
      outfitPillWidthValue = '',
      outfitPillHeightValue = '',
      outfitPillColorValue = '',
      outfitPillBGColorValue = '',
      outfitPillFontSizeValue = '',
      isGlobalOutfitHeaderSectionVisibleWeb = false,
      isGlobalOutfitHeaderSectionVisibleApp = false,
      currentNavId = '',
      categoryId = '',
      isOutfitCarouselPillDesignEnabled = false,
      outfitCarouselPillCategoriesAB = [],
    } = this.props;

    const { isHeaderStickyClassPresent, stickyHeaderHeight, middleNavHeight } = this.state;

    const extraConfig = {
      addBgdToTransparentImgEnabled,
      backgroundColorsForPng,
      isDamImageV2Enabled,
      isDamImageV2EnabledPLP,
      isDamImageV2EnabledPDP,
      isGroupModulesEnabled,
      isGroupModulesEnabledApp,
      isNewLoginScreen,
      isHpHLSEnabled,
      disableVideosForAppleDeviceValue,
      isModuleJAppV2,
      isOutfitCarouselModuleAppV2,
      outfitCarouselPillCategories,
      outfitPillWidthValue,
      outfitPillHeightValue,
      outfitPillColorValue,
      outfitPillBGColorValue,
      outfitPillFontSizeValue,
      isGlobalOutfitHeaderSectionVisibleWeb,
      isGlobalOutfitHeaderSectionVisibleApp,
      currentNavId,
      categoryId,
      isHeaderStickyClassPresent,
      stickyHeaderHeight,
      isOutfitCarouselPillDesignEnabled,
      outfitCarouselPillCategoriesAB,
      headerMiddleNavHeight: middleNavHeight,
    };

    return (
      <LabelsContext.Provider
        value={{
          extraConfig,
        }}
      >
        {children}
      </LabelsContext.Provider>
    );
  }
}

LabelsProvider.defaultProps = {
  backgroundColorsForPng: {},
  isDamImageV2Enabled: false,
  isDamImageV2EnabledPLP: false,
  isDamImageV2EnabledPDP: false,
  isGroupModulesEnabled: false,
  isGroupModulesEnabledApp: false,
  isNewLoginScreen: false,
  isHpHLSEnabled: false,
  isModuleJAppV2: false,
  isOutfitCarouselModuleAppV2: false,
  addBgdToTransparentImgEnabled: null,
  disableVideosForAppleDeviceValue: true,
  outfitCarouselPillCategories: [],
  outfitPillWidthValue: '',
  outfitPillHeightValue: '',
  outfitPillColorValue: '',
  outfitPillBGColorValue: '',
  outfitPillFontSizeValue: '',
  isGlobalOutfitHeaderSectionVisibleWeb: false,
  isGlobalOutfitHeaderSectionVisibleApp: false,
  currentNavId: '',
  categoryId: '',
  isOutfitCarouselPillDesignEnabled: false,
  outfitCarouselPillCategoriesAB: [],
};

LabelsProvider.propTypes = {
  children: PropTypes.shape({}).isRequired,
  backgroundColorsForPng: PropTypes.shape({}),
  isDamImageV2Enabled: PropTypes.bool,
  isDamImageV2EnabledPLP: PropTypes.bool,
  isDamImageV2EnabledPDP: PropTypes.bool,
  isGroupModulesEnabled: PropTypes.bool,
  isGroupModulesEnabledApp: PropTypes.bool,
  isNewLoginScreen: PropTypes.bool,
  isHpHLSEnabled: PropTypes.bool,
  isModuleJAppV2: PropTypes.bool,
  isOutfitCarouselModuleAppV2: PropTypes.bool,
  addBgdToTransparentImgEnabled: PropTypes.bool,
  disableVideosForAppleDeviceValue: PropTypes.bool,
  outfitCarouselPillCategories: PropTypes.shape([]),
  outfitPillWidthValue: PropTypes.string,
  outfitPillHeightValue: PropTypes.string,
  outfitPillColorValue: PropTypes.string,
  outfitPillBGColorValue: PropTypes.string,
  outfitPillFontSizeValue: PropTypes.string,
  isGlobalOutfitHeaderSectionVisibleWeb: PropTypes.bool,
  isGlobalOutfitHeaderSectionVisibleApp: PropTypes.bool,
  currentNavId: PropTypes.string,
  categoryId: PropTypes.string,
  isOutfitCarouselPillDesignEnabled: PropTypes.bool,
  outfitCarouselPillCategoriesAB: PropTypes.shape([]),
};

const mapStateToProps = (state) => {
  return {
    addBgdToTransparentImgEnabled: getAddBgdToTransparentImgEnabled(state),
    backgroundColorsForPng: getImgBackgroundColorForPng(state),
    isDamImageV2Enabled: getIsDamImageV2Enabled(state),
    isDamImageV2EnabledPLP: getIsDamImageV2EnabledPLP(state),
    isDamImageV2EnabledPDP: getIsDamImageV2EnabledPDP(state),
    isGroupModulesEnabled: getIsGroupModulesEnabled(state),
    isGroupModulesEnabledApp: getIsGroupModulesEnabledApp(state),
    isNewLoginScreen: getIsNewLoginScreen(state),
    isHpHLSEnabled: getIsHpHLSEnabled(state),
    disableVideosForAppleDeviceValue: disableVideosForAppleDevice(state),
    isModuleJAppV2: getIsModuleJV2(state),
    isOutfitCarouselModuleAppV2: getIsOutfitCarouselModuleV2(state),
    outfitCarouselPillCategories: getOutfitCarouselPillCategories(state),
    outfitPillWidthValue: getOutfitPillWidthVal(state),
    outfitPillHeightValue: getOutfitPillHeightVal(state),
    outfitPillColorValue: getOutfitPillColorVal(state),
    outfitPillBGColorValue: getOutfitPillBgColorVal(state),
    outfitPillFontSizeValue: getOutfitPillFontSizeVal(state),
    isGlobalOutfitHeaderSectionVisibleWeb: getIsHeaderSectionDisabledWeb(state),
    isGlobalOutfitHeaderSectionVisibleApp: getIsHeaderSectionDisabledApp(state),
    currentNavId: getCurrentNavId(state),
    categoryId: getCategoryId(state),
    isOutfitCarouselPillDesignEnabled: getIsOutfitCarouselPillEnabled(state),
    outfitCarouselPillCategoriesAB: getOutfitCarouselPillCategoriesAB(state),
  };
};

export default connect(mapStateToProps)(LabelsProvider);
